export default __webpack_public_path__ + "static/media/tf logo.340075d9.png";